export default {
  d: "M221.1,9.1L109.6,120.6H0v270.8h109.6L221.1,503h49.7V9.1H221.1z M223.1,437.3l-93.7-93.7H47.8V168.4h81.6l93.7-93.7\n\t\t\tV437.3zM343.5,137.7l-33.8,33.8c46.6,46.6,46.6,122.4,0,169l33.8,33.8C408.7,309.1,408.7,202.9,343.5,137.7zM428,53.2L394.2,87c45.1,45.1,70,105.2,70,169s-24.9,123.9-70,169l33.8,33.8c54.2-54.2,84-126.2,84-202.8\n\t\t\tS482.2,107.4,428,53.2z",
  viewBox: "0 0 512 512"
}
